
const digest = 'be56738d5fbda3f9a984fd6a73127fefb47455d93cda656414f8115eb3b4cff1';
const css = `._iconButton_1pp7n_1 {
  padding: 10px !important;
  margin: 0 !important;
  min-width: unset !important;
  border-radius: 5px !important;
}

._topLeft_1pp7n_8 {
  position: absolute !important;
  top: 10px !important;
  left: 10px !important;
}

._topRight_1pp7n_14 {
  position: absolute !important;
  top: 10px !important;
  right: 10px !important;
}`;

(function() {
  if (typeof document === 'undefined') {
    return;
  }
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"iconButton":"_iconButton_1pp7n_1","topLeft":"_topLeft_1pp7n_8","topRight":"_topRight_1pp7n_14"};
export { css, digest };
  